// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__EN1z1"};